import { flow } from "lodash-es";
import axios from "axios";
import { injectAction } from "../common/api/v2/axios-contrib/action-injection";
import { injectRegion } from "../common/api/v2/axios-contrib/region-injection";
import { checkResponseSchema } from "../common/api/v2/axios-contrib/response-schema";
// import { confirmToLogin, unauthorized } from "../common/api/v2/axios-contrib/unauthorized";
import { assignRequestIdPlugin } from "../common/api/v2/axios-contrib/assign-request-id";
import type { Router } from "vue-router";

export const axiosInstance = axios.create({
  // klog 接口时间可能很长
  timeout: 30000,
});

export function setupAxiosInstance(router: Router) {
  flow(
    assignRequestIdPlugin(),
    injectAction,
    injectRegion(),
    // unauthorized(async () => {
    //   await confirmToLogin(router);
    // }),
    checkResponseSchema,
  )(axiosInstance);
}
